<template>
    <div class="card">
        <div class="card-header">
            <div class="card-header-title">
                {{ rate.carrier }} {{ rate.service }}
            </div>
        </div>

        <div class="card-content">
            <div class="content">
                <p>
                    Delivery in {{ rate.delivery_days }} day{{ rate.delivery_days !== 1 ? 's' : '' }}
                </p>
                <p v-if="(rate.delivery_date ?? '') !== ''">
                    {{ formatDeliveryDate(rate.delivery_date) }} ({{ rate.delivery_date_guaranteed ? 'Guaranteed' : 'Not Guaranteed' }})
                </p>
                <p
                    v-else
                    class="is-italic"
                >
                    No estimated delivery date available
                </p>
            </div>
        </div>

        <div class="card-footer">
            <div class="card-footer-item">
                ${{ rate.rate }} {{ rate.currency }}
            </div>

            <div
                v-if="!hidePurchaseButton"
                class="card-footer-item"
            >
                <button
                    class="button is-small is-warning"
                    @click.prevent="$emit('select', rate)"
                >
                    Purchase Label
                </button>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import type {IRate} from "@easypost/api/types/Shipment";
import dayjs from "dayjs";

const props = defineProps<{
    rate: IRate;
    hidePurchaseButton?: boolean;
}>();

function formatDeliveryDate(date: string): string {
    const day = dayjs(date);

    return `${day.format('MMMM D, YYYY')} by ${day.format('h:mma z')}`;
}
</script>
